import React from "react"
import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"

const GridItem = ({ blok }) => (
  <div className="grid_item gs_reveal" 
  {...storyblokEditable(blok)}
  key={blok._uid}>
    <div className="grid_item_inner">
      {blok.grid_content.map(blok => (
        <StoryblokComponent key={blok._uid} blok={blok} />
      ))}
    </div>
  </div>
)

export default GridItem
